import { formatValidQueryParamUrlCommaSeparated } from "utils/common";
import { emptySplitApi } from "./empty-split-api";

import type { Prompt, PromptFilter, PromptInput } from "./types/prompts.type";

export const DEFAULT_PROMPTS_QUERY = "{id,prompt}";

export const promptsApi = emptySplitApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getLastPrompts: builder.query<Prompt[], PromptFilter>({
      query: ({
        ordering = "-pk",
        query = DEFAULT_PROMPTS_QUERY,
        limit = 5,
        ...rest
      }) => ({
        url: `/ai/prompts/${formatValidQueryParamUrlCommaSeparated(
          rest,
          true
        )}&ordering=${ordering}&limit=${limit}&query=${query}`,
        method: "GET",
      }),
      providesTags: ["Prompt"],
      transformResponse: (
        response: { count: number; results: Prompt[] } | Prompt[]
      ) => {
        if ("results" in response) {
          return response.results;
        }
        return response;
      },
    }),
    createPrompt: builder.mutation<Prompt, PromptInput>({
      query: (request) => ({
        url: "/ai/prompts/",
        method: "POST",
        body: request,
      }),
      invalidatesTags: ["Prompt"],
    }),
  }),
});

export const { useGetLastPromptsQuery, useCreatePromptMutation } = promptsApi;
